/**
 * TMS sayfalarındaki (Create Road Shipment, Weekly Plan) "read-only + Edit" kilidinin ortak hali.
 * Var olan bir kayıt kilitli açılır; kullanıcı "Edit"e basınca form düzenlemeye açılır.
 *
 *   const [readOnlyMode, setReadOnlyMode] = useState(Boolean(recordId));
 *
 *   {readOnlyMode && (
 *       <ReadOnlyBanner message="This account is in read-only view. Click Edit to make changes."
 *                       onEdit={() => setReadOnlyMode(false)} />
 *   )}
 *   <ReadOnlyFieldset readOnly={readOnlyMode}>...form...</ReadOnlyFieldset>
 *
 * Sekmeler fieldset'in dışında bırakılmalı ki kilitliyken de gezilebilsin.
 */
import React from "react";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export const ReadOnlyBanner = ({ message, onEdit, editLabel = "Edit", mb = 2 }) => (
    <MDBox mb={mb}>
        <MDBox
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            gap={2}
            sx={{
                p: 2,
                borderRadius: "10px",
                background: "#FFF8E1",
                border: "1px solid #FFD54F",
                textAlign: "left",
            }}
        >
            <MDBox display="flex" alignItems="center" gap={1.5}>
                <LockOutlinedIcon sx={{ color: "#B8860B" }} />
                <MDTypography variant="button" fontWeight="bold" sx={{ color: "#7A5B00" }}>
                    {message}
                </MDTypography>
            </MDBox>
            <Button
                variant="contained"
                startIcon={<EditIcon />}
                onClick={onEdit}
                style={{ backgroundColor: "#B8860B", color: "#FFFFFF" }}
            >
                {editLabel}
            </Button>
        </MDBox>
    </MDBox>
);

export const ReadOnlyFieldset = ({ readOnly, children }) => (
    <fieldset
        disabled={readOnly}
        style={{
            border: "none",
            padding: 0,
            margin: 0,
            minWidth: 0,
            opacity: readOnly ? 0.65 : 1,
            // fieldset[disabled] only locks real form controls; the date
            // picker buttons and autocomplete popups are cut off here too.
            pointerEvents: readOnly ? "none" : "auto",
            transition: "opacity .15s ease",
        }}
    >
        {children}
    </fieldset>
);
